<div class="filter-header">
  <h3 class="filter__title">{{ title }}</h3>
  <mat-icon matDialogClose class="close-btn">close</mat-icon>
</div>
